import { GET_ALL_POI, GET_COMPANY_OFFICES } from '../constants/urls';
import zfetch, { METHOD_GET } from '../pages/common/utils/zfetch';

const getAllPOI = workspaceId => {
  const options = {
    method: METHOD_GET,
    params: { workspace_id: workspaceId },
  };

  return zfetch(GET_ALL_POI, options).then(res => res.json());
};

const getOffices = () => {
  const options = {
    method: METHOD_GET,
  };
  return zfetch(GET_COMPANY_OFFICES, options).then(res => res.json());
};

export { getAllPOI, getOffices };
